var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfowhiteicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.602,
    height: 14.601,
    viewBox: "0 0 14.602 14.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-icon",
    transform: "translate(-672.814 -589.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M371.5,116.143a.715.715,0,1,0,.434.333.715.715,0,0,0-.434-.333Z",
    transform: "translate(310.109 475.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M283.625,193.741h-.011c-.675.243-1.537.775-1.347.063l1.306-4.873c.182-.678-.824-.647-1.451-.389a9.132,9.132,0,0,0-2.017,1.408h0a.267.267,0,0,0,.252.456h.011c.675-.243,1.537-.775,1.347-.063l-1.306,4.873c-.182.678.824.647,1.451.389a9.135,9.135,0,0,0,2.017-1.408.267.267,0,0,0-.253-.456Z",
    transform: "translate(398.074 405.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M105.3,28a7.3,7.3,0,1,0,3.649.978A7.3,7.3,0,0,0,105.3,28Zm0,13.785a6.494,6.494,0,1,1,4.585-1.9,6.494,6.494,0,0,1-4.585,1.9Z",
    transform: "translate(574.816 561.001)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfowhiteicon);
export default __webpack_public_path__ + "static/media/Infowhiteicon.280a7c8961257c71ccc2969dc93b4a4e.svg";
export { ForwardRef as ReactComponent };